<template>
    <div>
        <div class="card-wrapper" v-for="(item, index) in collectionsList" :key="item.id">
            <v-card class="collection-item" :style="getImgUrl(item.picture)">
                <v-card-text>
                    <div :class="{ 'additional-info': true, 'last-item': index===2 }">
                        <div class="additional-info-subtitle">{{ $t('collections1') }}</div>
                        <div class="additional-info-title">{{item.investmentHorizon === 3 ? $t('collections4') : (item.investmentHorizon === 2 ? $t('collections2') : $t('collections3'))}}</div>
                        <div class="additional-info-wines" v-for="(wine, wineIndex) in item.wines" :key="wineIndex">
                            <div class="additional-info-title">
                                <div class="country-flag" :style="{ background: `url(${wine.countryFlagUrl}) no-repeat center` }"></div>
                                <div v-if="wine.displayWineName">
                                    <div class="wine-vintage-name">{{wine.displayWineName}}</div>
                                </div>
                                <div v-else="wine.wineName">
                                    <div class="wine-vintage-name">{{wine.vintage}} {{wine.wineName}}</div>
                                </div>
                                <div v-if="!wine.displayWineName && !wine.wineName">
                                    <div class="wine-vintage-name">{{wine.vintage}} {{wine.producerName}}</div>
                                </div>
                            </div>
                            <div class="additional-info-subtitle">{{wine.caseQuantity}} {{wine.caseQuantity > 1 ? 'cases' : 'case'}} of {{wine.caseSize}}</div>
                        </div>
                        <div class="arrow-right"></div>
                        <div class="arrow-left"></div>
                    </div>
                    <div class="background-shadow"></div>
                    <div class="background-redirect" v-on:click="openCollection(item)"></div>
                    <h3 class="collection-header">{{ item.title }}</h3>
                    <div class="collection-subtitle">{{ cutDescription(item.subtitle) }}</div>

                    <div class="investments-container investments-container1">
                        <div class="investments-wrapper-left">
                            <div class="investment">{{ $t('collections1') }}</div>
                            <div :class="{'investments-percentages': true, 'investments-percentages-2': item.investmentHorizon === 2, 'investments-percentages-3': item.investmentHorizon === 3}">
                                <div class="collection-percent"></div>
                                <div class="collection-percent"></div>
                                <div class="collection-percent"></div>
                            </div>
                            <div class="investment-years">{{item.investmentHorizon === 3 ? $t('collections4') : (item.investmentHorizon === 2 ? $t('collections2') : $t('collections3'))}}</div>
                        </div>
                        <div class="investments-wrapper-right">
                            <div class="collection-price">{{formatPrice(item.price.toLocaleString("fi-FI", { minimumFractionDigits: 2, maximumFractionDigits: 2 }).replace(',','.'))}}</div>
                            <div class="collections-save">{{ $t('collections5') }} {{formatPrice(item.youSave.toLocaleString("fi-FI", { minimumFractionDigits: 2, maximumFractionDigits: 2 }).replace(',','.'))}}</div>
                        </div>
                    </div>

                    <div class="investments-container buttons-container" v-if="item.availableQuantity !== 0">
                        <div class="buttons-left">
                            <button class="cart-btn btn-secondary" v-on:click="() => { addCollectionToCart(item) }">{{ $t('add-basket') }}</button>
                        </div>
                    </div>
                    <div class="buttons-container sold-wrapper" v-else>
                        <div class="sold-label">{{ $t('sold-out') }}</div>
                    </div>
                </v-card-text>
            </v-card>

            <div class="card-additional-text" v-if="index===0">
                <ul>
                    <li>{{ $t('lp-investor39') }}</li>
                    <li>{{ $t('lp-investor40') }}</li>
                    <li>{{ $t('lp-investor41') }}</li>
                </ul>
            </div>
            <div class="card-additional-text" v-else-if="index===1">
                <ul>
                    <li>{{ $t('lp-investor33') }}</li>
                    <li>{{ $t('lp-investor34') }}</li>
                    <li>{{ $t('lp-investor35') }}</li>
                </ul>
            </div>
            <div class="card-additional-text" v-else>
                <ul>
                    <li>{{ $t('lp-investor36') }}</li>
                    <li>{{ $t('lp-investor37') }}</li>
                    <li>{{ $t('lp-investor38') }}</li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapGetters } from "vuex";
    import {AOrders, AUser} from '@/store/actions';
    import {MOrders} from "@/store/mutations";
    import {GCommon, GOrders} from "@/store/getters";

export default {
    name: "HomeTopCollections",
    props: ['collectionsList', 'additionalData'],
    data () {
        return {
            valid: true,
            deleteDialog: false,
            editDialog: false,
            editAddressSuccess: {
                visible: false,
                text: 'Address added successfully!'
            },
            editAddressFail: {
                visible: false,
                text: 'Please review again all the information and try again!'
            },
            isDefaultBilling: this.addressList === 1,
            isDefaultShipping: this.addressList === 1,
            newAddress: {},
            swiperOptions: {
                slidesPerView: 1,
                spaceBetween: 30,
                loop: true,
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev'
                },
                pagination: {
                    el: '.swiper-pagination',
                    clickable: true
                },
                dynamicBullets: true
            }
        }
    },
    computed: {
        ...mapGetters({
            cartItemsList: GOrders.GET_CART_ITEMS,
            mobileCheck: GCommon.GET_MOBILE_VERSION
        })
    },
    methods: {
        formatPrice(price) {
            return `€${price}`
        },
        openCollection(item) {
            if (this.goToDetailsPage) {
                return;
            }
            this.goToDetailsPage = true;
            let wineCollectionsView = this;
            this.$store.dispatch(AOrders.GET_COLLECTION_DETAILS, { id: item.id, lang: this.$i18n.locale }).then(() => {
                setTimeout(function() {
                    wineCollectionsView.goToDetailsPage = false
                }, 800);
                this.$store.dispatch(AUser.GET_USER_COMMISSION);
                this.$store.dispatch(AUser.GET_ADDRESSES);
                this.$router.push(this.localePath({ path: `/collection-details/${item.id}` }));
                window.scrollTo({
                    top: 0,
                    left: 0,
                    behavior: 'smooth'
                });
            })
        },
        cutDescription(str) {
            if (str.length > 60) {
                return (str.substring(0, 60) + '...')
            } else {
                return str
            }
        },
        addCollectionToCart (collection) {
            let _payload = {};
            let availableInCart = this.cartItemsList.filter(item => item.id === collection.id);
            let availableInCartGifts = this.cartItemsList.filter(item => item.christmasGift === true);

            if (availableInCart.length) {
                if (availableInCart[0].unitsCount >= collection.availableQuantity) {
                    alert('There are not enough collections on the market');
                    return;
                }
            }

            if (availableInCartGifts.length) {
                this.$nuxt.$emit('carterror', false);
                return;
            }

            this.$gtm.push({ ecommerce: null });
            this.$gtm.push({
                event: "add_to_cart",
                ecommerce: {
                    currency: "EUR",
                    value: collection.price,
                    purchase: {
                        price: collection.price,
                        id: Math.floor(Math.random() * 10000) + 1
                    },
                    items: [
                        {
                            item_id: collection.id,
                            item_name: collection.title,
                            coupon: "",
                            discount: 0,
                            index: 0,
                            item_brand: "Vindome Wine Collection",
                            item_category: "Wine collection",
                            item_list_id: "wine_collections",
                            price: collection.price,
                            quantity: 1
                        }
                    ]
                }
            });

            _payload.availableQuantity = collection.availableQuantity;
            _payload.collectionOrderIds = collection.collectionOrderIds;
            _payload.investmentHorizon = collection.investmentHorizon;
            _payload.isEnPrimeur = collection.isEnPrimeur;
            _payload.id = collection.id;
            _payload.price = collection.price;
            _payload.title = collection.title;
            _payload.picture = collection.picture;
            _payload.unitsCount = 1;
            _payload.youSave = collection.youSave;
            _payload.totalCases = 0;
            _payload.wines = [];

            collection.wines.forEach(element => {
                let _wine = {};
                _wine.caseQuantity = element.caseQuantity;
                _wine.pricePerCase = element.pricePerCase;
                _payload.wines.push(_wine);
                _payload.totalCases += element.caseQuantity;
            });
            this.$store.commit(MOrders.SET_COLLECTION_CART, { collections: _payload, addRemove: true, resetCart: false });
        },
        getImgUrl(imgUrl) {
            return "background-image: url('" + imgUrl + "')"
        }
    }
}
</script>

<style scoped>
.card-additional-text {
    margin-top: 16px;
}
.card-additional-text ul {
    padding-left: 0;
    list-style-position: outside;
}
.card-additional-text li {
    font-family: Montserrat, sans-serif;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 24px;
    color: #000000;
}
.investment,
.investment-years,
.collections-save {
    font-family: Roboto, sans-serif;
}
.collections-save {
    white-space: nowrap;
}
.sold-label {
    width: 130px;
    height: 36px;
    line-height: 38px;
    background: #efefef;
    text-align: center;
    margin-top: 4px;
    position: relative;
    top: 8px;
    font-weight: 700;
    color: #000;
}
.additional-info {
    display: none;
    padding: 18px;
    background: #FFFFFF;
    border-radius: 8px;
    -webkit-box-shadow: 0 2px 8px 0 rgba(0,0,0,0.75);
    -moz-box-shadow: 0 2px 8px 0 rgba(0,0,0,0.75);
    box-shadow: 0 2px 8px 0 rgba(0,0,0,0.75);
    position: absolute;
    left: calc(100% - 14px);
    z-index: 3;
    width: 100%;
}
.additional-info.last-item {
    left: unset;
    right: calc(100% - 14px);
}
.arrow-right {
    content: '';
    vertical-align: middle;
    margin: auto;
    position: absolute;
    top: 0;
    left: -8px;
    bottom: 0;
    width: 15px;
    height: 15px;
    background: #fff;
    border-top: 1px solid #ccc;
    border-right: 1px solid #ccc;
    -moz-transform: rotate(-135deg);
    -webkit-transform: rotate(-135deg);
}
.arrow-left {
    content: '';
    display: none;
    vertical-align: middle;
    margin: auto;
    position: absolute;
    top: 0;
    right: -8px;
    bottom: 0;
    width: 15px;
    height: 15px;
    background: #fff;
    border-top: 1px solid #ccc;
    border-right: 1px solid #ccc;
    -moz-transform: rotate(45deg);
    -webkit-transform: rotate(45deg);
}
.additional-info.last-item .arrow-right {
    display: none;
}
.additional-info.last-item .arrow-left {
    display: block;
}

.additional-info-wines {
    margin-top: 16px;
}
.additional-info-subtitle {
    font-family: Roboto, sans-serif;
    size: 14px;
    line-height: 19px;
    color: #707070;
}
.additional-info-title {
    font-family: Roboto, sans-serif;
    size: 16px;
    line-height: 19px;
    color: #000000;
    font-weight: 500;
    position: relative;
}
.country-flag {
    width: 30px;
    height: 15px;
    background-size: contain !important;
    display: block;
    top: 1px;
    position: absolute;
}
.wine-vintage-name {
    display: inline-block;
    text-indent: 40px;
}
.card-wrapper {
    display: inline-block;
    width: calc((100% - 32px)/3);
    margin-right: 16px;
    vertical-align: top;
}
.collection-item {
    font-family: 'Montserrat', Arial, Helvetica, sans-serif;
    width: 100%;
    border-radius: 10px;
    vertical-align: top;
    border: 1px solid #cccccc;
    box-shadow: none;
    padding: 32px;
    background-size: cover;
    background-position-y: center;
    user-select: none;
    position: relative;
}
.collection-item:hover .additional-info {
    display: block;
}
.background-shadow {
    background: rgba(0,0,0,0.64);
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border-radius: 10px;
}
.background-redirect {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 50%;
    z-index: 99;
}
.collection-item:hover .background-redirect {
    cursor: pointer;
}
.card-wrapper:nth-child(3n+0) {
    margin-right: 0;
}
.collection-header {
    color: #ffffff;
    white-space: pre-line;
    font-size: 23px;
    line-height: 25px;
    position: relative;
    z-index: 2;
    font-weight: bold;
    height: 50px;
}
.collection-item:hover .collection-header {
    color: var(--brand);
}
.collection-subtitle {
    font-size: 16px;
    color: #fff;
    width: 100%;
    position: relative;
    z-index: 2;
    margin-top: 24px;
    font-weight: 500;
    min-height: 44px;
}
.investments-container {
    padding: 35px 0 16px;
    font-size: 14px;
    color: #fff;
    font-weight: 300;
    position: relative;
    z-index: 2;
}
.investments-container1 {
    height: 119px;
}
.buttons-container {
    padding-top: 14px;
    padding-bottom: 0;
}
.investments-wrapper-left,
.investments-wrapper-right,
.buttons-left {
    display: inline-block;
    width: calc(50% - 2px);
    vertical-align: top;
}
.buttons-left {
    width: auto;
}
.investments-wrapper-right {
    text-align: right;
}
.investments-percentages {
    margin-bottom: 5px;
}
.investments-percentages .collection-percent {
    display: inline-block;
    width: 25%;
    background: #707070;
    height: 8px;
    border-radius: 2px;
    margin-right: 5px;
    opacity: 0.64;
}
.investments-percentages .collection-percent:nth-child(1),
.investments-percentages.investments-percentages-2 .collection-percent:nth-child(2),
.investments-percentages.investments-percentages-3 .collection-percent:nth-child(2),
.investments-percentages.investments-percentages-3 .collection-percent:nth-child(3) {
    background: var(--brand);
    opacity: 1;
}
.cart-btn {
    position: relative;
    z-index: 2;
    color: #ffffff;
    font-size: 16px;
    font-weight: 500;
    min-height: 40px;
    padding: 0.5em 1em;
    width: 100%;
}
.collection-price {
    font-weight: 700;
    font-size: 25px;
    margin-top: 10px;
    margin-bottom: 17px;
}

.learn-more-btn {
    color: #ffffff;
    width: 125px;
    float: right;
    text-align: center;
    position: relative;
    z-index: 2;
    margin: 0 auto;
    font-weight: 500;
    font-size: 16px;
    height: 40px;
}
.learn-more-btn svg {
    fill: #ffffff;
    position: relative;
    top: 5px;
}
.learn-more-btn:hover {
    color: var(--brand);
    cursor: pointer;
}
.learn-more-btn:hover svg {
    fill: var(--brand);
}

@media(min-width: 768px) and (max-width: 1024px) {
    .collection-item {
        width: 380px;
        margin: 0 auto 20px;
        box-sizing: border-box;
        display: block;
    }
}
@media(max-width: 767px) {
    .card-wrapper {
        width: 100%;
        margin-right: 0;
        padding: 0 15px;
        margin-bottom: 32px;
    }
    .card-wrapper:nth-child(3n+0) {
        margin-bottom: 0;
    }
    .swiper-button-next,
    .swiper-button-prev {
        display: none;
    }
    .collection-item {
        width: 100%;
        margin-right: 0;
        margin-left: 0;
        box-sizing: border-box;
        margin-bottom: 20px;
    }
    .cart-btn,
    .learn-more-btn {
        font-size: 14px;
    }
    .collection-item:hover .additional-info {
        display: none;
    }
}
@media(max-width: 360px) {
    .collection-header {
        font-size: 20px;
        line-height: 23px;
    }
    .collection-subtitle {
        font-size: 15px;
    }
    .investments-container {
        font-size: 12px;
    }
    .collection-price {
        font-size: 22px;
    }
}
</style>

<style>
.collection-item .v-card__text {
    padding: 0;
}
.home .home-top-collections .swiper-container {
    height: 380px !important;
    margin-bottom: 32px;
}
</style>
